import { universalTransferDocumentTypes } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { namesList as counterpartiesList } from "sources/books/cargoOwners";
import { list as registriesList } from "sources/books/registries";

export const config = {
    type: {
        label: "Статус УПД",
        inputProps: { name: "type" },
        options: universalTransferDocumentTypes,
        required: true,
        validators: [requiredField],
        unClearable: true,
    },
    classificationTypeId: {
        label: "Тип номенклатуры",
        inputProps: { name: "classificationTypeId" },
        propName: "name",
        menuPortalTarget: document.body,
        required: true,
        validators: [requiredField],
    },
    registryId: {
        label: "Существующий реестр",
        inputProps: { name: "registryId" },
        url: registriesList,
        filterPropName: "id",
        propName: (item) =>
            `Реестр ${item.id}${item.counterparty?.displayName ? `, ${item.counterparty.displayName}` : ""}`,
        menuPortalTarget: document.body,
    },
    manualBidIds: {
        label: "ID заявок",
        inputProps: { name: "manualBidIds" },
        textarea: true,
    },
    counterpartyId: {
        label: "Контрагент",
        inputProps: { name: "counterpartyId" },
        url: counterpartiesList,
        propName: "name",
        menuPortalTarget: document.body,
    },
    from: {
        label: "Период от",
        inputProps: { name: "from", type: "date" },
        inPortal: true,
    },
    to: {
        label: "Период до",
        inputProps: { name: "to", type: "date" },
        inPortal: true,
    },
};

export const initialState = {
    ...getInitialStateFromConfig(config),
    bids: [],
    loadingBids: false,
    sourceMode: "search",
    selectedBidIds: [],
    type: "InvoiceAndTransfer",
};
